/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  Button,
  Card,
  Collapse,
  Flex,
  Image,
  Progress,
  Tag,
} from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { CrossIcon } from "../../../../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { SubServiceType } from "../../../../../PotentialDeals/ducks/types";
import { updateProposalById } from "../../../../../PotentialDeals/ducks/services";

interface PropsType {
  newEstimate: boolean;
  textAreaContent?: string;
  setTextAreaContent?: React.Dispatch<React.SetStateAction<string>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  activeRecord: SubServiceType | null;
  singleGroupData: any;
  resetSidebar: () => void;
  groupedData?: any[];
  activeServiceId?: string | null;
  activeType?: string | null;
}

export default function EstimateSidebar(props: PropsType) {
  const {
    setLoading,
    activeRecord,
    newEstimate,
    textAreaContent,
    groupedData,
    setTextAreaContent,
    singleGroupData,
    resetSidebar,
    activeServiceId,
    activeType,
  } = props;

  // const items = [
  //   {
  //     key: "1",
  //     label: (
  //       <Button
  //         type="text"
  //         className="no-hover"
  //         icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //       >
  //         Edit
  //       </Button>
  //     ),
  //   },
  //   {
  //     key: "2",
  //     label: (
  //       <Button
  //         type="text"
  //         className="delete-hover"
  //         icon={<Image src="/images/table/delete-icon.svg" preview={false} />}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //       >
  //         Delete
  //       </Button>
  //     ),
  //   },
  // ];

  const submitSummary = () => {
    const payload = {
      summary: textAreaContent ?? "",
    };
    const estimateId = "12345"; // Replace with actual estimateId
    updateProposalById(estimateId, payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Summary updated");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const [laborHrs, setLaborHrs] = useState(0);
  const [laborPrice, setLaborPrice] = useState(0);
  const [singleMaterialCost, setSingleMaterialCost] = useState(0);
  const [singleMaterialPrice, setSingleMaterialPrice] = useState(0);
  const [totalLaborCost, setTotalLaborCost] = useState(0);
  const [totalMaterialCost, setTotalMaterialCost] = useState(0);
  const [totalGM, setTotalGM] = useState(0);
  const [salesTaxPrice, setSalesTaxPrice] = useState(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [filterService, setFilterService] = useState<null | any>(null);

  useEffect(() => {
    if (singleGroupData && activeServiceId && activeType) {
      let totalMaterialPrice = 0;
      let totalMaterialCost = 0;

      if (activeType === "simple") {
        const filteredService = singleGroupData?.services?.find(
          (service: any) => service?.entity_id === activeServiceId
        );

        if (filteredService?.material?.length > 0) {
          filteredService.material.forEach((mat: any) => {
            if (mat?.unit_cost && mat?.use_rate) {
              const singleTotalNeed = filteredService?.qty / mat.use_rate || 0;
              const singleUnitPrice =
                (mat.unit_cost * 100) /
                (100 - Number(filteredService?.gross_margin_perc) || 0);
              totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
              totalMaterialPrice += singleTotalNeed * singleUnitPrice;
            }
          });
        }

        setFilterService(filteredService);
        setLaborPrice(
          (singleGroupData?.labor_rate * 100) /
            (100 - filteredService?.gross_margin_perc || 0)
        );
        let laborHrs = 0;
        const HourPerVisit =
          filteredService?.qty / filteredService?.prod_rate || 0;
        if (filteredService?.frequency === "one_time") {
          laborHrs = HourPerVisit ?? 0;
        } else {
          laborHrs = HourPerVisit * filteredService?.visit || 0;
        }

        console.log("laborHrs", filteredService, laborHrs);

        setLaborHrs(laborHrs);
        setSingleMaterialCost(totalMaterialCost);
        setSingleMaterialPrice(totalMaterialPrice);
      } else {
        const serviceGroup = singleGroupData?.service_groups?.find(
          (group: any) =>
            group?.services?.some(
              (service: any) => service?.entity_id === activeServiceId
            )
        );

        const filteredService = serviceGroup?.services?.find(
          (service: any) => service?.entity_id === activeServiceId
        );

        if (filteredService?.material?.length > 0) {
          filteredService.material.forEach((mat: any) => {
            if (mat?.unit_cost && mat?.use_rate) {
              const singleTotalNeed = filteredService?.qty / mat.use_rate || 0;
              const singleUnitPrice =
                (mat.unit_cost * 100) /
                (100 - Number(filteredService?.gross_margin_perc) || 0);
              totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
              totalMaterialPrice += singleTotalNeed * singleUnitPrice;
            }
          });
        }

        setFilterService(filteredService);
        setLaborPrice(
          (singleGroupData?.labor_rate * 100) /
            (100 - filteredService?.gross_margin_perc || 0)
        );

        let laborHrs = 0;
        const HourPerVisit =
          filteredService?.qty / filteredService?.prod_rate || 0;
        if (filteredService?.frequency === "one_time") {
          laborHrs = HourPerVisit ?? 0;
        } else {
          laborHrs = HourPerVisit * filteredService?.visit || 0;
        }

        setLaborHrs(laborHrs);
        setSingleMaterialCost(totalMaterialCost);
        setSingleMaterialPrice(totalMaterialPrice);
      }
    }
  }, [singleGroupData, activeServiceId, activeType]);

  useEffect(() => {
    if (groupedData && groupedData?.length > 0) {
      let totalLaborHours = 0;
      let totalMaterialCost = 0;

      let calculatedTotalPrice = 0;
      let calculatedTotalCost = 0;

      groupedData?.forEach((groupData: any) => {
        (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
          serviceGroup?.services?.forEach((service: any) => {
            calculatedTotalPrice += service?.total_price || 0;
            calculatedTotalCost += service?.total_cost || 0;
          });
        });

        // Calculate total cost from top-level services
        (groupData?.services ?? []).forEach((service: any) => {
          calculatedTotalPrice += service?.total_price || 0;
          calculatedTotalCost += service?.total_cost || 0;
        });
      });

      let grossMargin = 0;
      if (calculatedTotalPrice && calculatedTotalCost) {
        grossMargin = parseFloat(
          Number(
            ((calculatedTotalPrice - calculatedTotalCost) /
              calculatedTotalPrice) *
              100
          ).toFixed(1)
        );
      }

      const SALES_TAX_PERCENTAGE = 8.5;
      const salesTaxTotalAmount =
        calculatedTotalPrice * (SALES_TAX_PERCENTAGE / 100);
      const totalAmountIncludingTax =
        calculatedTotalPrice + salesTaxTotalAmount;

      groupedData?.forEach((item: any) => {
        item?.service_groups?.forEach((serviceGroup: any) => {
          serviceGroup?.services?.forEach((service: any) => {
            let laborHrs = 0;
            const HourPerVisit = service?.qty / service?.prod_rate || 0;
            if (service?.frequency === "one_time") {
              laborHrs = HourPerVisit ?? 0;
            } else {
              laborHrs = HourPerVisit * service?.visit || 0;
            }
            const laborHours = laborHrs || 0;
            totalLaborHours += laborHours * item?.labor_rate;
            if (service?.material?.length > 0) {
              service.material.forEach((mat: any) => {
                if (mat?.unit_cost && mat?.use_rate) {
                  const singleTotalNeed = service?.qty / mat.use_rate || 0;
                  totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
                }
              });
            }
          });
        });
        item?.services?.forEach((service: any) => {
          let laborHrs = 0;
          const HourPerVisit = service?.qty / service?.prod_rate || 0;
          if (service?.frequency === "one_time") {
            laborHrs = HourPerVisit ?? 0;
          } else {
            laborHrs = HourPerVisit * service?.visit || 0;
          }
          const laborHours = laborHrs || 0;
          totalLaborHours += laborHours * item?.labor_rate;
          if (service?.material?.length > 0) {
            service.material.forEach((mat: any) => {
              if (mat?.unit_cost && mat?.use_rate) {
                const singleTotalNeed = service?.qty / mat.use_rate || 0;
                totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
              }
            });
          }
        });
      });

      setFinalTotalAmount(totalAmountIncludingTax);
      setSalesTaxPrice(salesTaxTotalAmount);
      setTotalGM(grossMargin);
      setTotalLaborCost(totalLaborHours);
      setTotalMaterialCost(totalMaterialCost);
    }
  }, [groupedData]);

  const totalCost = totalLaborCost + totalMaterialCost;
  const costBreakdownFormula = (totalLaborCost / totalCost) * 100;

  // console.log("filterService", filterService);

  return (
    <div className="innerRight">
      <Card className="estimateCardInner">
        {activeRecord ? (
          <>
            <div className="innerRightBox">
              <h4 className="titleBar">
                Service details
                <div className="btns_action">
                  <Button
                    type="text"
                    icon={<CrossIcon />}
                    onClick={() => resetSidebar()}
                  />
                </div>
              </h4>
            </div>
            <Card className="innerImageCard">
              <div className="image_tag">
                <Image
                  src={
                    filterService?.image_url ||
                    "/images/company/no_image_grey.png"
                  }
                  preview={false}
                />
                <Tag
                  className={
                    filterService?.who_performs === "in_house" ||
                    filterService?.service_provision_type === "in_house"
                      ? "violet_tag defaultTag typeLabel"
                      : "orange_tag defaultTag typeLabel"
                  }
                >
                  {filterService?.who_performs === "in_house" ||
                  filterService?.service_provision_type === "in_house"
                    ? "In-house"
                    : "Subcontracted"}
                </Tag>
              </div>
              <div
                style={{
                  marginBottom:
                    filterService?.type === "subservice" ? 0 : "16px",
                }}
              >
                <h5>{filterService?.name}</h5>
              </div>

              <>
                {filterService?.frequency !== "one_time" && (
                  <div style={{ marginBottom: "16px" }}>
                    <h6
                      style={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontWeight: "500",
                        marginBottom: "4px",
                      }}
                    >
                      Frequency
                    </h6>
                    <h6
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {filterService?.frequency === "bi_weekly" ? (
                        "Bi-weekly"
                      ) : (
                        <span style={{ textTransform: "capitalize" }}>
                          {filterService?.frequency}
                        </span>
                      )}
                    </h6>
                  </div>
                )}

                <Flex gap={16} justify="space-between" wrap="wrap">
                  <div className="estimateSidebarItem">
                    <h6>Total cost</h6>
                    <h5>
                      ${" "}
                      {filterService?.total_cost
                        ? Number(
                            filterService?.total_cost.toFixed(2)
                          ).toLocaleString()
                        : 0}
                    </h5>
                  </div>
                  <div className="estimateSidebarItem">
                    <h6>Total price</h6>
                    <h5>
                      ${" "}
                      {filterService?.total_price
                        ? Number(
                            filterService?.total_price.toFixed(2)
                          ).toLocaleString()
                        : 0}
                    </h5>
                  </div>
                  <div className="estimateSidebarItem">
                    <h6>Service GM</h6>
                    <h5>
                      {filterService?.gross_margin_perc ? (
                        <>
                          {filterService?.gross_margin_perc} <span>%</span>
                        </>
                      ) : (
                        "-"
                      )}
                    </h5>
                  </div>
                </Flex>
              </>
              {/* )} */}
            </Card>

            <Card>
              <Collapse
                items={[
                  {
                    key: "1",
                    label: "Labor",
                    children: (
                      <Flex gap={16} justify="space-between" wrap="wrap">
                        <div className="estimateSidebarItem">
                          <h6>Production rate</h6>
                          <h5>
                            {filterService?.prod_rate
                              ? Number(
                                  filterService?.prod_rate?.toFixed(2)
                                ).toLocaleString()
                              : 0}{" "}
                            {filterService?.unit ? (
                              <span
                                style={{
                                  color: "#6C7478",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                }}
                              >
                                {filterService?.unit ?? ""}/hr
                              </span>
                            ) : null}
                          </h5>
                        </div>
                        {filterService?.frequency !== "one_time" && (
                          <>
                            <div className="estimateSidebarItem">
                              <h6>Hrs per visit</h6>
                              <h5>
                                {filterService?.hrs_per_visit
                                  ? Number(
                                      filterService?.hrs_per_visit?.toFixed(2)
                                    ).toLocaleString()
                                  : 0}
                              </h5>
                            </div>
                            <div className="estimateSidebarItem">
                              <h6>Total hrs</h6>
                              <h5>
                                {filterService?.hrs_per_visit
                                  ? (
                                      Number(
                                        filterService?.hrs_per_visit ?? 0
                                      ) * Number(filterService?.visit ?? 0)
                                    )
                                      .toFixed(2)
                                      .toLocaleString()
                                  : 0}
                              </h5>
                            </div>
                          </>
                        )}

                        <div className="estimateSidebarItem">
                          <h6>Labor rate</h6>
                          <h5>
                            $
                            {singleGroupData?.labor_rate
                              ? Number(
                                  singleGroupData?.labor_rate?.toFixed(2)
                                ).toLocaleString()
                              : 0}
                          </h5>
                        </div>
                        <div className="estimateSidebarItem">
                          <h6>Total labor cost</h6>
                          <h5>
                            $
                            {laborHrs
                              ? Number(
                                  (
                                    laborHrs * singleGroupData?.labor_rate
                                  )?.toFixed(2)
                                ).toLocaleString()
                              : 0}
                          </h5>
                        </div>
                        <div className="estimateSidebarItem">
                          <h6>Total labor price</h6>
                          <h5>
                            $
                            {laborHrs
                              ? Number(
                                  (laborHrs * laborPrice)?.toFixed(2)
                                ).toLocaleString()
                              : 0}
                          </h5>
                        </div>
                        <div className="estimateSidebarItem">
                          <h6>Labor GM</h6>
                          <h5>{filterService?.gross_margin_perc}%</h5>
                        </div>
                      </Flex>
                    ),
                  },
                ]}
                defaultActiveKey={["1"]}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 265 : 90} />
                )}
              />
            </Card>

            {filterService?.material && filterService?.material?.length > 0 && (
              <Card>
                <Collapse
                  items={[
                    {
                      key: "1",
                      label: "Materials",
                      children: (
                        <div className="card_collapse">
                          {filterService?.material &&
                          filterService?.material?.length > 0 ? (
                            <Flex gap={16} justify="space-between" wrap="wrap">
                              <div className="estimateSidebarItem">
                                <h6>Total material cost</h6>
                                <h5>
                                  ${" "}
                                  {Number(
                                    singleMaterialCost?.toFixed(4)
                                  ).toLocaleString()}
                                </h5>
                              </div>
                              <div className="estimateSidebarItem">
                                <h6>Total material price</h6>
                                <h5>
                                  ${" "}
                                  {Number(
                                    singleMaterialPrice?.toFixed(4)
                                  ).toLocaleString()}
                                </h5>
                              </div>
                              <div className="estimateSidebarItem">
                                <h6>Materials GM</h6>
                                <h5>{filterService?.gross_margin_perc}%</h5>
                              </div>
                            </Flex>
                          ) : (
                            <Card className="no_data_add_btn">
                              There are no materials
                              {/* <Button className="outlined-btn btn-sm">
                              <PlusIcon /> Add
                            </Button> */}
                            </Card>
                          )}
                        </div>
                      ),
                    },
                  ]}
                  defaultActiveKey={["1"]}
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 265 : 90} />
                  )}
                />
              </Card>
            )}
          </>
        ) : (
          <>
            <div className="estimateTop">
              <div className="estimateSidebarHeader">
                <h3>Estimate summary</h3>

                {/* <Dropdown
                  menu={{
                    items,
                  }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className="only_icon"
                    icon={<MoreOutlined />}
                  />
                </Dropdown> */}
              </div>
              <div className="sidebarTextarea">
                <TextArea
                  placeholder="Add any notes or special instructions here..."
                  value={textAreaContent}
                  onChange={(e) =>
                    setTextAreaContent && setTextAreaContent(e.target.value)
                  }
                />
                {!newEstimate && (
                  <Button
                    className="mint-btn"
                    disabled={!textAreaContent}
                    onClick={submitSummary}
                  >
                    Save
                  </Button>
                )}
              </div>
            </div>
            <Card className="cardCollapse">
              <Collapse
                items={[
                  {
                    key: "1",
                    label: "Contract total",
                    children: (
                      <div className="collapse_card_child_wrap">
                        <div className="collapse_card_child">
                          <Progress
                            percent={100}
                            success={{
                              percent: finalTotalAmount > 0 ? 100 - totalGM : 0,
                              strokeColor: "#00A07D",
                            }}
                            showInfo={false}
                            type="line"
                            strokeColor={
                              finalTotalAmount > 0 ? "#8FDFCA" : "#DEE5E6"
                            }
                            size={["100%", 40]}
                          />
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">Gross margin:</div>
                          <div className="card_child_right">{totalGM}%</div>
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">Total amount:</div>
                          <div className="card_child_right">
                            ${" "}
                            {Number(
                              finalTotalAmount.toFixed(2)
                            ).toLocaleString()}
                          </div>
                        </div>
                        <div className="collapse_card_child sales_tax">
                          <div className="card_child_left">
                            Incl. sales tax (8.5%):
                          </div>
                          <div className="card_child_right">
                            ${" "}
                            {Number(salesTaxPrice?.toFixed(2)).toLocaleString()}
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
                defaultActiveKey={["1"]}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 265 : 90} />
                )}
              />
            </Card>

            <Card className="cardCollapse">
              <Collapse
                items={[
                  {
                    key: "1",
                    label: "Cost structure",
                    children: (
                      <div className="collapse_card_child_wrap cost_structure">
                        <div className="collapse_card_child">
                          <Progress
                            percent={100}
                            success={{
                              percent:
                                totalLaborCost > 0 ? costBreakdownFormula : 0,
                              strokeColor: "#6454F4",
                            }}
                            showInfo={false}
                            type="line"
                            strokeColor={
                              totalLaborCost > 0 ? "#44A6F1" : "#DEE5E6"
                            }
                            // trailColor="#8FDFCA"
                            size={["100%", 40]}
                            style={{ borderRadius: "8px" }}
                          />
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">
                            <Badge color="#6454F4" text="Labor:" />
                          </div>
                          <div className="card_child_right">
                            ${" "}
                            {Number(
                              totalLaborCost?.toFixed(2)
                            ).toLocaleString()}
                          </div>
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">
                            <Badge color="#44A6F1" text="Materials:" />
                          </div>
                          <div className="card_child_right">
                            ${" "}
                            {Number(
                              totalMaterialCost?.toFixed(2)
                            ).toLocaleString()}
                          </div>
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">
                            <Badge color="#D94B73" text="Subcontractors:" />
                          </div>
                          <div className="card_child_right">$ 0</div>
                        </div>
                        <div className="collapse_card_child">
                          <div className="card_child_left">
                            <Badge color="#98A3A9" text="Other:" />
                          </div>
                          <div className="card_child_right">$ 0</div>
                        </div>
                        <div className="collapse_card_child total_cost_div">
                          <div className="card_child_left">Total cost:</div>
                          <div className="card_child_right">
                            ${" "}
                            {Number(
                              (totalLaborCost + totalMaterialCost)?.toFixed(2)
                            ).toLocaleString()}
                          </div>
                        </div>
                      </div>
                    ),
                  },
                ]}
                defaultActiveKey={["1"]}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 265 : 90} />
                )}
              />
            </Card>
          </>
        )}
      </Card>
    </div>
  );
}
